import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RestoreSmsCampaign as RestoreSmsCampaignMutation,
    GetSmsBroadcastsVariables,
    GetSmsBroadcasts as GetSmsBroadcastsQuery,
} from 'nutshell-graphql-types';

import RESTORE_SMS_CAMPAIGN from '../mutations/restore-sms-campaign.graphql';
import GET_SMS_BROADCASTS from '../queries/get-sms-broadcasts.graphql';

export function useRestoreSmsCampaign(queryVariables: GetSmsBroadcastsVariables): {
    restoreCampaign: (id: string) => Promise<any>;
    isRestoring: boolean;
    error: string | null | undefined;
} {
    const [restoreCampaign, {loading, error}] = useMutation<
        RestoreSmsCampaignMutation,
        Record<any, any>
    >(RESTORE_SMS_CAMPAIGN);

    return {
        restoreCampaign: (id: string) =>
            restoreCampaign({
                variables: {input: {id}},
                update: (proxy, mutationResults) => {
                    const cacheResult: GetSmsBroadcastsQuery | null | undefined = proxy.readQuery({
                        query: GET_SMS_BROADCASTS,
                        variables: queryVariables,
                    });

                    const restoredBroadcast = mutationResults.data?.smsCampaignRestore?.campaign;

                    if (!restoredBroadcast) return;

                    if (cacheResult) {
                        proxy.writeQuery({
                            query: GET_SMS_BROADCASTS,
                            variables: queryVariables,
                            data: {
                                smsBroadcasts: cacheResult.smsBroadcasts.filter(
                                    (broadcast) => broadcast.id !== restoredBroadcast.id
                                ),
                            },
                        });
                    }
                },
            }),
        isRestoring: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
